<template>
  <div>
    <b-card class="standardpage">
      <b-card-header id="tooltip-cars">
        <b-row>
          <b-col cols="12" class="text-right text-sm-left pt-1">
            <i :class="carhire.icon" class="mr-1"></i>
            {{ carhire.title }}
            <!-- <span v-if="eventcode"> for {{ eventtitle }} </span> -->
          </b-col>
        </b-row>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-0">
          <b-card-body class="py-0">

            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Issue Date" label-size="sm">
                  <b-input-group>
                    <daterangepicker size="sm" ref="date" v-model="issued_at" :opens="'right'"
                      :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="false"
                      :single-date-picker="false">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="issued_at = {
                        startDate: null,
                        endDate: null,
                      }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Traveller/Driver" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="surname" :debounce="carhire.debounce" placeholder="Driver"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!surname" @click="surname = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <b-input-group class="treeselect_all justify-content-end pr-2px">
                    <span style="padding-top: 0.3em" class="text-primary" id="event-blocked">Blocked</span>
                    <b-form-checkbox id="event-blocked-check" v-model="iseventblocked" class="z-0">
                    </b-form-checkbox>
                  </b-input-group>
                  <treeselect placeholder="Select event..." searchPromptText="Type at least 4 chars..."
                    v-model="eventcode" :clearable="true" :multiple="true" :async="true"
                    :load-options="treeselect_loadEvent" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>

              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                  <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="slac"
                    :clearable="true" :multiple="true" :async="true" :load-options="treeselect_loadSLAC"
                    :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                    search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col> -->

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm" class="mb-0">
                  <b-input-group class="treeselect_all justify-content-end pr-2px">
                    <span style="padding-top: 0.3em" class="text-primary" id="slaclike-tooltip">Like</span>
                    <b-form-checkbox id="slaclike" v-model="slaclike_visible" class="z-0">
                    </b-form-checkbox>
                    <span style="padding-top: 0.3em" class="text-primary" id="slac-blocked">Blocked</span>
                    <b-form-checkbox id="slac-blocked-check" v-model="isslacblocked" class="z-0">
                    </b-form-checkbox>
                  </b-input-group>
                  <b-input-group v-if="!slaclike_visible">
                    <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="slac"
                      :clearable="true" :multiple="true" :async="true" :load-options="treeselect_loadSLAC"
                      :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                      search-nested>
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-input-group>
                </b-form-group>

                <b-input-group v-if="slaclike_visible">
                  <b-form-input v-model="slaclike" :debounce="carhire.debounce" placeholder="Client SL A/C (LIKE %)"
                    trim></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" :disabled="!slaclike" @click="slaclike = ''">
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="RefNo ( Paste List )" label-for="referenceno" label-cols="12">
                  <b-input-group class="z-0">
                    <b-form-tags input-id="referenceno" v-model="referenceno" tag-variant="primary" separator=" ,;"
                      placeholder="Paste RefNo (333..,333...)" size="sm" class="h-29" add-button-text="+" add-on-change
                      remove-on-delete add-button-variant="outline-primary"></b-form-tags>

                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="referenceno = []">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <b-tooltip target="reflist1-tooltip" triggers="hover">Use ticket number in related fields? Check this
                  option to see
                  associated exchange and re-issued tickets.
                </b-tooltip>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="ConfirmNo" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="confirmationno" :debounce="carhire.debounce" placeholder="ConfirmNo"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!confirmationno"
                        @click="confirmationno = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Date Travel" label-size="sm">
                  <b-input-group>
                    <daterangepicker size="sm" ref="travel_at" v-model="travel_at" :opens="'right'"
                      :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="true"
                      :single-date-picker="'range'">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="travel_at = {
                        startDate: null,
                        endDate: null,
                      }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Your Ref/PO" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="yourref" :debounce="carhire.debounce"
                      placeholder="Your Ref/PO"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!yourref" @click="yourref = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Supplier B/L" label-size="sm">
                  <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..." v-model="blac"
                    :clearable="true" :multiple="true" :async="true" :load-options="treeselect_loadBLAC"
                    :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                    search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>



              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Booking Type" label-size="sm">
                  <treeselect v-model="type" :clearable="true" :options="type_options"></treeselect>
                </b-form-group>
              </b-col> -->

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Equipment (SIPP)" label-size="sm">
                  <b-input-group class="treeselect_all" style="left:95px; top:-15px">
                    <i class="fa fa-leaf text-primary"></i>
                  </b-input-group>
                  <treeselect placeholder="Equipment (SIPP)" v-model="equipment" :clearable="true" :multiple="true"
                    :options="options_equipment" :matchKeys="['id']">
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>




              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Details" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="comments" :debounce="carhire.debounce" placeholder="Details"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!comments" @click="comments = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->


              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Agent" label-size="sm">
                  <b-input-group class="treeselect_all justify-content-end pr-2px">
                    <span style="padding-top: 0.3em" class="text-primary" id="agent-blocked">Blocked</span>
                    <b-form-checkbox id="agent-blocked-check" v-model="isagentblocked" class="z-0">
                    </b-form-checkbox>
                  </b-input-group>
                  <b-input-group>
                    <b-form-input v-model="agent" placeholder="Agent"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!agent" @click="agent = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Status" label-size="sm">
                  <treeselect placeholder="Select status..." v-model="status" :clearable="true" :multiple="true"
                    :options="status_options" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                  </treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Invoice No? ( Paste List )" label-for="reflist" label-cols="12">
                  <b-input-group class="treeselect_all justify-content-end pr-2px">
                    <b-form-checkbox-group id="isinvoiced" v-model="isinvoiced" :options="options_isinvoiced" size="sm"
                      value-field="id" text-field="label" name="radio-options" class="z-0" style="padding-top: 0.2em">
                    </b-form-checkbox-group>
                  </b-input-group>
                  <b-input-group class="z-0">
                    <b-form-tags input-id="reflist" v-model="invoiceno" tag-variant="primary" separator=" ,;"
                      placeholder="Paste Ref (IA519826,IA519827,...)" size="sm" class="h-29" add-button-text="+"
                      add-on-change remove-on-delete add-button-variant="outline-primary"></b-form-tags>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="invoiceno = null">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>


            </b-row>

            <!-- <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Issued" label-size="sm">
                  <b-input-group>
                    <daterangepicker size="sm" ref="date" v-model="modified" :opens="'right'" :locale-data="locale_data"
                      :ranges="locale_ranges" :linkedCalendars="false" :single-date-picker="false">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="modified = {
                        startDate: null,
                        endDate: null,
                      }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Date Pickup" label-size="sm">
                  <b-input-group>
                    <daterangepicker size="sm" ref="travel_at" v-model="travel_at" :opens="'right'"
                      :locale-data="locale_data" :ranges="locale_ranges" :linkedCalendars="true"
                      :single-date-picker="'range'">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="
                        travel_at = {
                          startDate: null,
                          endDate: null,
                        }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Status" label-size="sm">
                  <treeselect placeholder="Select status..." v-model="status" :clearable="true"
                    :options="status_options" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Agent" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="agent" :debounce="carhire.debounce" placeholder="Agent"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!agent" @click="agent = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Driver" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="traveller" :debounce="carhire.debounce" placeholder="Driver"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!traveller" @click="traveller = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                  <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="slac"
                    :clearable="true" :multiple="true" :async="true" :load-options="treeselect_loadSLAC"
                    :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                    search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect placeholder="Select event..." searchPromptText="Type at least 4 chars..."
                    v-model="eventcode" :clearable="true" :async="true" :load-options="treeselect_loadEvent"
                    :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                    search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm">
                  <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..." v-model="blac"
                    :clearable="true" :async="true" :load-options="treeselect_loadBLAC" :show-count="true"
                    :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Confirmation No" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="confirmationno" :debounce="carhire.debounce" placeholder="Confirmation No"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!confirmationno"
                        @click="confirmationno = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Invoice" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="invoiceno" :debounce="carhire.debounce" placeholder="Invoice"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!invoiceno" @click="invoiceno = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row> -->
          </b-card-body>
        </b-card>

        <div class="px-3 mx-0 text-left">
          <div v-if="carhire.pastespecial">
            <b-row class="mt-2" no-gutters>
              <b-col cols="6">
                <b-form-group>
                  <b-form-checkbox-group id="carhires_paste_selected" v-model="carhire.paste_selected"
                    :options="carhire.paste_options" value-field="id" text-field="label"></b-form-checkbox-group>
                </b-form-group>
              </b-col>
              <b-col cols="auto" class="text-right ml-auto">
                <b-row>
                  <!-- <b-col cols="auto">
                    <b-link squared size="sm" variant="outline-primary" @click="download()">
                      <i class="fa fa-download"></i>
                      Template
                    </b-link>
                  </b-col> -->
                  <b-col cols="auto">
                    <b-link size="sm" variant="outline-primary" @click="carhire_saveit()">
                      <i class="fa fa-floppy-o"></i>
                      Save It
                    </b-link>
                  </b-col>
                  <b-col cols="auto">
                    <b-link size="sm" variant="outline-primary" @click="carhire_headers()">
                      Headers
                    </b-link>
                  </b-col>
                  <b-col cols="auto">
                    <b-link size="sm" variant="outline-primary" @click="carhire_paste_read()">
                      <i class="fa fa-magic"></i>
                      Read It
                    </b-link>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label-cols="12">
                  <b-form-textarea id="data" v-model="carhire.paste" placeholder="Paste car data" rows="6"
                    class="smalltextarea courier"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </div>

          <d-table classdivtable="availtable datatable" refid="carhire" :icon="carhire.icon"
            :toolbarlibrary="carhire.toolbarlibrary" :tools="carhire.tools" :badges="carhire.badges"
            :fields="carhire.fields" :items="carhire.items" :busy="carhire.busy" :offset="carhire.offset"
            :limit="carhire.limit" :page="carhire.page" @load="carhire_load" @click="carhire_click"
            @select="carhire_select">
          </d-table>
        </div>
      </div>

      <div v-show="component">
        <component :is="component" :selection="carhire.selected" :config="cconfig" @discard="carhire_click('discard')"
          @refresh="carhire_click('refresh')"></component>
      </div>

      <b-row class="px-3">
        <b-col>
          <b-alert :show="message ? true : false" variant="success">
            <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
              <b-col>
                <span v-html="message"></span></b-col></b-row>
          </b-alert></b-col>
      </b-row>

    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

import CarHireEdit from "./Components/CarHireEdit";
import CarHireInvoice from "./Components/CarHireInvoice";
import CarHireAmend from "./Components/CarHireAmend";
import CarHirePublish from "./Components/CarHirePublish";

function tabToObjArr(text) {

  let raw = text.trim().split('"').join("")
  let allcols = raw.split("\t")

  let headers = raw.split("\n")[0].split("\t")
  let cb = headers.length - 1
  let cols = []
  for (let i = 0; i < allcols.length; i++) {
    if (i == cb) {
      let parts = allcols[i].trim().split("\n")
      for (let k = 0; k < parts.length; k++) {
        cols.push(parts[k].trim())
      }
      cb += headers.length - 1
    } else {
      cols.push(allcols[i].trim().split("\n").join(",").replace(/\s+/g, ' '))
    }
  }
  console.log('cols=', cols)

  cb = headers.length - 1
  let rows = []
  let item = {}
  let k = 0
  for (let i = 0; i < cols.length; i++) {
    if (i == cb) {
      item[headers[k]] = cols[i]
      rows.push(item)
      cb += headers.length
      item = {}
      k = 0
    } else {
      item[headers[k]] = cols[i]
      k += 1
    }
  }
  return rows;
}

export default {
  name: "Cars",
  components: {
    CarHireEdit,
    CarHireInvoice,
    CarHireAmend,
    CarHirePublish
  },
  async mounted() {
    try {
      const response = await this.$apollo.query({
        query: gql`
            query setup_carsipps {
              setup_carsipps {
                id
                label
              }
            }
          `,
      });
      this.options_equipment = response.data.setup_carsipps;
    } catch (error) {
      console.log(error);
    }
    await this.carhire_load()
  },
  data() {
    return {
      busy: false,
      id: null,
      status: [],
      issued_at: {
        startDate: this.$moment().startOf("year").format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
      },
      travel_at: {
        startDate: null,
        endDate: null,
      },
      slac: [],
      slaclike: null,
      slaclike_visible: null,
      isslacblocked: false,
      blac: [],
      equipment: [],
      options_equipment: [],
      surname: null,
      eventcode: [],
      iseventblocked: false,
      locator: [],
      referenceno: [],
      agent: null,
      isagentblocked: false,
      confirmationno: null,
      yourref: null,
      invoiceno: [],
      isinvoiced: ["0"],
      options_isinvoiced: [
        { id: '1', label: 'Yes' },
        { id: '0', label: 'No' },
      ],
      status: ['ready', 'unsubmitted'],
      status_options: [
        { id: "ready", label: "Ready" },
        { id: "unsubmitted", label: "Unsubmitted" },
        { id: "pending", label: "Pending" },
        { id: "cancelled", label: "Cancelled" },
      ],
      carhire: {
        title: "Car Hire",
        icon: "fa fa-car text-info",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        pastespecial: false,
        paste: null,
        paste_selected: ["firstrowheader", "reversenamecap"],
        paste_options: [
          { id: "firstrowheader", label: "First Row Headers", disabled: true },
          { id: "secondrowskip", label: "Second Row Skip" },
          { id: "filldown", label: "Fill Down" },
        ],
        // tools: "go,filter,export,add,clipboard,publish,amend,edit,pastespecial,deleteconfirm,invoice,credit,migrate",
        tools: "go,filter,export,add,clipboard,amend,edit,pastespecial,deleteconfirm,invoice,credit",
        toolbarlibrary: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-share text-dark",
            position: "toolbar",
            action: "publish",
            label: "Publish",
            component: {
              name: "CarHirePublish",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-repeat text-primary",
            position: "toolbar",
            action: "amend",
            label: "Amend",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-repeat text-orange",
            position: "toolbar",
            action: "migrate",
            label: "Migrate",
            component: {
              name: "",
            },
          },
        ],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-right w-50px",
          },
          {
            key: "issued_at",
            label: "Issued",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .format("DD/MM/YYYY HH:mm:ss");
              }
              return result;
            },
          },
          {
            key: "referenceno",
            label: "RefNo",
            sortable: true,
          },
          {
            key: "blac",
            label: "BL A/C",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            class: "d-none d-xl-table-cell",
          },
          {
            key: "eventcode",
            label: "Event",
            sortable: true,
            class: "d-none d-xl-table-cell",
          },
          {
            key: "passenger",
            label: "Traveller/Driver",
            sortable: true,
          },
          {
            key: "reference",
            label: "Conf No",
            sortable: true,
            class: "text-center d-none d-xl-table-cell",
          },
          {
            key: "start_at",
            label: "Date Pickup",
            sortable: true,
            class: "text-center d-none d-xl-table-cell",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000).utc(false)
                  .format("DD/MM/YYYY HH:mm");
              }
              return result;
            }
          },
          // {
          //   key: "dropoffdate",
          //   label: "Date Dropoff",
          //   sortable: true,
          //   class: "text-center d-none d-xl-table-cell",
          // },
          // {
          //   key: "duration",
          //   label: "Days",
          //   sortable: true,
          //   class: "d-none d-sm-table-cell",
          // },
          {
            key: "cost",
            label: "Cost",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
          },
          {
            key: "markup",
            label: "Markup",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
          },
          {
            key: "sale",
            label: "Sale",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
          },
          {
            key: "agent",
            label: "Agent",
            sortable: true,
            class: "d-none d-xl-table-cell",
          },
          {
            key: "status",
            label: "Status",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "invoiceno",
            label: "InvoiceNo",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [
          {
            key: "status",
            type: "badge",
            Cancelled: "danger",
            Unsubmitted: "info",
            Pending: "warning",
            Ready: "purple",
            formatter: (value, key, item) => {
              switch (value) {
                case "cancelled":
                  return "Cancelled";
                case "unsubmitted":
                  return "Unsubmitted";
                case "pending":
                  return "Pending";
                case "ready":
                  return "Ready";

                default:
                  return value;
              }
            },
          },
          {
            key: "blac",
            type: "pill",
            class: "white",
          },

        ],
        items: [],
        selected: [],
        denied: [],
      },
    };
  },
  watch: {
    async issued_at() {
      await this.carhire_load(0);
    },
    async travel_at() {
      await this.carhire_load(0);
    },
    async equipment() {
      await this.carhire_load(0);
    },
    async status() {
      await this.carhire_load(0);
    },
    async agent() {
      await this.carhire_load(0);
    },
    async isagentblocked() {
      console.log('watch isagentblocked')
      await this.carhire_load(0);
    },
    async surname() {
      await this.carhire_load(0);
    },
    async slac() {
      await this.carhire_load(0);
    },
    async isslacblocked() {
      console.log('watch isslacblocked')
      await this.carhire_load(0);
    },
    async slaclike_visible() {
      console.log('watch slaclike_visible')
      await this.carhire_load(0);
    },
    async slaclike() {
      console.log('watch slaclike')
      await this.carhire_load(0);
    },
    async eventcode() {
      await this.carhire_load(0);
    },
    async iseventblocked() {
      console.log('watch iseventblocked')
      await this.carhire_load(0);
    },
    async blac() {
      await this.carhire_load(0);
    },
    async confirmationno() {
      await this.carhire_load(0);
    },
    // async invoiceno() {
    //   await this.carhire_load(0);
    // },
    async invoiceno() {
      console.log('watch invoiceno')
      if (this.invoiceno.length > 0) {
        this.issued_at = { startDate: null, endDate: null }
        this.isinvoiced = ["1"]
        await this.carhire_load(0);
      } else {
        this.isinvoiced = ["0"]
        this.issued_at = { startDate: this.$moment().startOf("year").format("YYYY-MM-DD"), endDate: this.$moment().format("YYYY-MM-DD") }
      }
    },
    async isinvoiced() {
      console.log('watch isinvoiced')
      if (this.isinvoiced) {
        if (JSON.stringify(this.isinvoiced) == '["0","1"]') {
          this.isinvoiced = ["1"]
        } else if (JSON.stringify(this.isinvoiced) == '["1","0"]') {
          this.isinvoiced = ["0"]
        }
      }
      await this.carhire_load(0);
    },
    async referenceno() {
      await this.carhire_load(0);
    },
    "window.width": {
      immediate: true,
      async handler(newVal, oldVal) {

        let state = this.carhire;

        // HIDE COLUMNS BELOW WIDTH
        if (newVal < 1500) {
          // state.fields[7].class = "d-none"
          // state.fields[7].class = "d-none"
        } else {
          // state.fields[7].class = "text-center"
          // state.fields[7].class = "text-center"
        }
        if (newVal < 1800) {
          state.fields[8].class = "d-none"
          state.fields[9].class = "d-none"
        } else {
          state.fields[8].class = "text-center"
          state.fields[9].class = "text-center"
        }
      },
    },
  },
  methods: {
    accessdenied() {
      this.carhire.denied = [];
      if (!this.user.permissions.includes("systems.development")) {
        this.carhire.denied.push("migrate");
      }
      if (!this.user.permissions.includes("carhire.admin")) {
        this.carhire.denied.push("publish");
        this.carhire.denied.push("amend");
      }
    },

    async carhire_load(offset, limit, page) {

      let state = this.carhire;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,
        issued_at: [
          this.issued_at.startDate
            ? this.$moment(this.issued_at.startDate).format("YYYY-MM-DD")
            : null,
          this.issued_at.endDate
            ? this.$moment(this.issued_at.endDate).format("YYYY-MM-DD")
            : null,
        ],
        travel_at: [
          this.travel_at.startDate
            ? this.$moment(this.travel_at.startDate).format("YYYY-MM-DD")
            : null,
          this.travel_at.endDate
            ? this.$moment(this.travel_at.endDate).format("YYYY-MM-DD")
            : null,
        ],
        blac: this.blac.length > 0 ? this.blac.join(",") : null,
        slac: this.slac.length > 0 ? this.slac.join(",") : null,
        slaclike: this.slaclike,
        isslacblocked: this.isslacblocked,
        equipment: this.equipment.length > 0 ? this.equipment.join(",") : null,
        eventcode: this.eventcode.length > 0 ? this.eventcode.join(",") : null,
        iseventblocked: this.iseventblocked,
        yourref: this.yourref,
        locator: this.locator.length > 0 ? this.locator.join(",") : null,
        referenceno: this.referenceno.length > 0 ? this.referenceno.join(",") : null,
        status: this.status.length > 0 ? this.status.join(",") : null,
        notes: this.notes,
        reference: this.confirmationno,
        invoiceno: this.invoiceno.length > 0 ? this.invoiceno.join(",") : null,
        isinvoiced: this.isinvoiced ? this.isinvoiced == "1" ? true : false : null,
        agent: this.agent,
        isagentblocked: this.isagentblocked,
        surname: this.surname,
        orderby: [["issued_at", "desc"]],
      };

      // } 
      try {
        const response = await this.$apollo.query({
          query: gql`
              query carhire(             
                $offset: Int
                $limit: Int
                $issued_at: [String]
                $slac: String
                $slaclike: String
                $isslacblocked: Boolean
                $eventcode: String
                $iseventblocked: Boolean
                $yourref: String
                $referenceno: String    
                $locator: String
                $status: String           
                $isinvoiced: Boolean                
                $type: String   
                $notes: String                   
                $reference: String
                $travel_at: [String]             
                $blac: String                                   
                $invoiceno: String  
                $agent: String 
                $isagentblocked: Boolean
                $surname: String
                $equipment: String
                $platform: String
                $account_id:String
                $orderby:[[String]]                   
                # $dateformat: String
              ) {
                    carhire(                 
                    offset: $offset
                    limit: $limit
                    issued_at: $issued_at
                    slac: $slac
                    slaclike: $slaclike
                    isslacblocked: $isslacblocked
                    eventcode: $eventcode
                    iseventblocked: $iseventblocked
                    yourref: $yourref
                    locator: $locator
                    referenceno: $referenceno
                    status: $status
                    isinvoiced: $isinvoiced     
                  #  hasnotes: $hasnotes   
                    notes: $notes               
                    type: $type
                    reference: $reference
                    travel_at: $travel_at                              
                    invoiceno: $invoiceno   
                    blac: $blac                               
                    agent: $agent  
                    isagentblocked: $isagentblocked
                    surname: $surname 
                    equipment: $equipment                   
                    platform: $platform
                    account_id: $account_id
                    orderby: $orderby
                    ) {
                    id
                    type
                    issued_at
                    referenceno
                    invoicetype
                    description                   
                    passenger
                    yourref
                    qty
                    start_at
                    blac  
                    reference
                    cost                    
                    markup
                    sale                                       
                    slac
                    eventcode             
                    agent
                    status
                    invoiceno  
                    updated_at
                    updated_by
                    rows
                    }
                }
                `,
          variables,
        });

        // USE LOCAL VARIABLE
        if (limit == 0) {
          state.selected = response.data.carhire
        } else {
          state.items = response.data.carhire;
        }
        this.message = null

      }

      catch (error) {
        console.log(error);
      }
      state.busy = false;
    },
    async carhire_click(a, ss) {

      this.message = ""

      let state = this.carhire;

      switch (a) {
        case "filter":
          this.showfilter = !this.showfilter;
          break;

        case "discard":
        case "go":
          this.component = null;
          this.carhire_load();
          break;
        case "pastespecial":
          state.pastespecial = !state.pastespecial
          break;
        case "add":
        case "edit":
          this.component = "CarHireEdit";
          break;
        case "publish":
          this.component = "CarHirePublish";
          break;
        case "delete":
          await this.carhire_deleteit(ss);
          break;
        case "amend":
          this.component = "CarHireAmend";
          break;
        case "migrate":
          await this.carhire_migrateit(ss);
          break;
        case "invoice":
          if (ss.length > 0) {
            if (ss[0].invoiceno) {
              this.message = null
              this.component = "CarHireInvoice";
            } else {
              // this.message = "Invoice has not been posted yet! use <i class='fa fa-share text-info'></i> Assign to draft an invoice."
              this.message = "Invoice has not been posted yet! Charge is awaiting an invoicing action."
              this.component = null;
            }
          }
          break;
        case "credit":
          if (ss.length > 0) {
            if (ss[0].invoiceno) {
              this.message = null
              await this.carhire_creditit(ss);
            } else {
              this.message = "You cannot credit an Invoice that has not been posted yet!."
              this.component = null;
            }
          }
      }
    },
    async carhire_select(ss, tools) {

      let state = this.carhire;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "clipboard", "export", "pastespecial", "publish", "migrate"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit", "notes", "view", "invoice", "credit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm", "amend"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async carhire_deleteit(ss) {
      console.log("carhire_deleteit", ss);

      let state = this.carhire;

      state.busy = true

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation carhire_delete($rows: [InventoryLine_input]) {
                carhire_delete(rows: $rows) {
                  id
                }
              }
            `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      state.busy = false

      await this.carhire_load(0);
    },


    async carhire_migrateit(s) {
      console.log("carhire_migrateit", s);

      let state = this.carhire
      state.busy = true;

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation carhire_migrate {
                carhire_migrate
              }
              `,
        });

      } catch (error) {
        console.log(error);
      }

      state.busy = false;

      await this.carhire_load(0);

    },

    async carhire_paste_read() {

      let state = this.carhire;

      if (state.paste) {
        state.busy = true
        let rows = tabToObjArr(state.paste)

        let rowstart = 1
        if (state.paste_selected.includes("secondrowskip")) {
          rowstart += 1
        }

        // MAKE OBJECT ITEMS
        let items = []
        for (let i = rowstart; i < rows.length; i++) {
          items.push(rows[i])
        }

        if (state.paste_selected.includes("filldown")) {
          let lastitem = {}
          for (let i = 0; i < items.length; i++) {
            let item = items[i]
            for (let prop in lastitem) {
              if (!item[prop]) {
                if (lastitem[prop]) {
                  item[prop] = lastitem[prop]
                }
              }
            }
            lastitem = item
          }
        }
        console.log('fill downs', rows)

        let found = null

        rows = []
        for (let i = 0; i < items.length; i++) {
          let obj = items[i]

          let carhire = {
            issued_at: (this.$moment().utc(true).unix() * 1000).toString()
          }

          for (let prop in obj) {

            let values = []
            try {
              if (obj[prop]) {
                let data = obj[prop].trim().toUpperCase()
                let colname = prop.toLowerCase()

                if (colname == 'reference' || colname == 'conf no' || colname == 'confirmationno') {
                  carhire.reference = data
                }
                if (colname == 'referenceno' || colname == 'ref no' || colname == 'reference no' || colname == 'refno') {
                  carhire.referenceno = data
                }
                if (colname == 'blac' || colname == 'bl a/c' || colname == 'supplier') {
                  carhire.blac = data
                }
                if (colname == 'slac' || colname == 'sl a/c' || colname == 'client') {
                  carhire.slac = data
                }
                if (colname == 'eventcode' || colname == 'event') {
                  carhire.eventcode = data
                }
                if (colname == 'duration' || colname == 'days') {
                  carhire.duration = data
                }
                if (colname == 'cost') {
                  carhire.cost = data
                }
                if (colname == 'markup') {
                  carhire.markup = data
                }

                if (colname == 'startcity') {
                  carhire.startcity = data
                }
                if (colname == 'endcity') {
                  carhire.endcity = data
                }
                if (colname == 'startlocation') {
                  carhire.startlocation = data
                }
                if (colname == 'endlocation') {
                  carhire.endlocation = data
                }

                if (colname == 'surname' || colname == 'driver' || colname == 'traveller') {
                  carhire.surname = data
                }

                if (colname == 'start_at' || colname == 'start datetime' || colname == 'pickup' || colname == 'date pickup') {
                  if (this.$moment(data, 'DD/MM/YYYY').isValid()) {
                    console.log('is valid', 'DD/MM/YYYY')
                    carhire.start_at = (this.$moment(data, 'DD/MM/YYYY HH:mm').utc(true).unix() * 1000).toString()
                    // start_at = this.$moment(data, 'DD/MM/YYYY HH:mm').format('HH:mm')
                  } else if (this.$moment(data, 'dddd Do MMMM YYYY').isValid()) {
                    console.log('is valid', 'dddd Do MMMM YYYY')
                    carhire.start_at = this.$moment(data, 'dddd Do MMMM YYYY').format('YYYY-MM-DD HH:mm')
                  }
                  // if (carhire.start_at) {
                  //   datetravel = this.$moment(carhire.start_at).format('YYYY-MM-DD')
                  // }
                }

                if (colname == 'end_at' || colname == 'end datetime' || colname == 'dropoff') {
                  if (this.$moment(data, 'DD/MM/YYYY').isValid()) {
                    console.log('is valid', 'DD/MM/YYYY')
                    carhire.end_at = (this.$moment(data, 'DD/MM/YYYY HH:mm').utc(true).unix() * 1000).toString()
                    // end_at = this.$moment(data, 'DD/MM/YYYY HH:mm').format('HH:mm')
                  } else if (this.$moment(data, 'dddd Do MMMM YYYY').isValid()) {
                    console.log('is valid', 'dddd Do MMMM YYYY')
                    carhire.end_at = this.$moment(data, 'dddd Do MMMM YYYY').format('YYYY-MM-DD HH:mm')
                  }
                  // if (carhire.end_at) {
                  //   datetravel = this.$moment(carhire.end_at).format('YYYY-MM-DD')
                  // }
                }

                if (colname == 'issued_at' || colname == 'issued') {
                  if (this.$moment(data, 'DD/MM/YYYY').isValid()) {
                    console.log('is valid', 'DD/MM/YYYY')
                    carhire.issued_at = (this.$moment(data, 'DD/MM/YYYY HH:mm').utc(true).unix() * 1000).toString()
                    // issued_at = this.$moment(data, 'DD/MM/YYYY HH:mm').format('HH:mm')
                  } else if (this.$moment(data, 'dddd Do MMMM YYYY').isValid()) {
                    console.log('is valid', 'dddd Do MMMM YYYY')
                    carhire.issued_at = this.$moment(data, 'dddd Do MMMM YYYY').format('YYYY-MM-DD HH:mm')
                  }
                }

                // if (colname == 'description' || colname == 'name') {
                //   carhire.description = data
                //   carhire.eventname = data
                // }

                // if (colname == 'po' || colname == 'yourref') {
                //   carhire.yourref = data.split("*")[0]
                //   carhire.yourref = carhire.yourref.split('-0000').join('')
                //   // ENDS WITH -
                //   if (carhire.yourref.slice(-1) == '-') {
                //     carhire.yourref = carhire.yourref.slice(0, carhire.yourref.length - 1)
                //   }
                // }
                // if (colname == 'value' || colname == 'cost') {
                //   if (data) {
                //     carhire.value = parseFloat(data).toFixed(2)
                //     carhire.cost = parseFloat(data).toFixed(2)
                //   }
                // }

                if (!carhire.equipment) { carhire.equipment = 'CDMR' }

                if (!carhire.cabin) { carhire.cabin = 'BUSINESS' }

                if (!carhire.agent) { carhire.agent = this.$store.state.user.initials }

                carhire.status = "ready"
              }

            } catch (error) {
              console.log('error here', error)
            }
          }
          // DE-DUPLICATE
          found = rows.find(o => o.reference == carhire.reference)
          if (!found) {
            rows.push(carhire)
          }
        }
        console.log('rows=', rows)

        state.items = rows

        state.busy = false
      }

    },
    async carhire_headers() {

      let state = this.carhire;

      let content = state.paste
      state.paste = "SLAC\tPO\n"
      if (content) {
        state.paste += content
      }
    },

    async carhire_saveit() {
      console.log("carhire_saveit");

      let state = this.carhire;

      state.busy = true;

      let variables = { rows: this.cleanit(state.items) };
      console.log("variables", variables);


      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation carhire_save($rows: [InventoryLine_input]) {
              carhire_save(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      state.busy = false;

    },

    async carhire_creditit(ss) {

      let state = this.carhire;

      if (await this.$bvModal.msgBoxConfirm('This will be a full credit and allow you to invoice the booking again.', {
        title: 'Please confirm you want to credit this invoice ' + ss[0].invoiceno + ' back onto Ghold?',
        size: 'lg',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'Yes',
        cancelTitle: 'No',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })) {

        state.busy = true;

        let variables = { rows: this.cleanit(ss) };
        console.log("variables", variables);

        try {
          const response = await this.$apollo.mutate({
            mutation: gql`
            mutation carhire_credit($rows: [InventoryLine_input]) {
              carhire_credit(rows: $rows) {
                id
              }
            }
          `,
            variables,
          });
          this.message = "<span class='text-primary'>Saved it.</span>";
        } catch (error) {
          this.message = "<span class='text-danger'>" + error.message + "</span>";
        }

      } else {

      }

      state.busy = false;

      await this.carhire_load(0);

    },

  },
};
</script>